import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { DEFAULT_ROWS_PER_PAGE, STARTING_TABLE_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING, FP_PHASE } from '../Utils/Constants';
const sNegControllerEndpoint = 'NegotiationLots';
const sFPControllerEndpoint = 'FirmPurchases';


export class FirmPurchasesAPI {

  getFirmPurchasesLots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, state = FP_PHASE, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (state)
      params.state = state;
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sNegControllerEndpoint + '/GetLotsList', { params });
  }

  finishFirmPurchasesLot(L1Id) {
    return axios.post(getBackendURL() + sFPControllerEndpoint + '/FinishL1FirmPurchases?L1Id=' + L1Id);
  }

}

export default FirmPurchasesAPI


// WEBPACK FOOTER //
// ./src/API/FirmPurchasesAPI.js